<template>
    <div class="
      flex justify-between px-[16px] items-center mb-[24px]

      lg:justify-center
    ">
        <div class="
          text-[20px]

          lg:text-[24px]

          font-semibold uppercase
        ">
            <slot />
        </div>
        <button @click="closeModal" class="
          lg:hidden

          mr-[8px] focus-outline-only
        ">
            <close-icon class="size-[16px]" />
        </button>
    </div>
</template>

<script>
    import CloseIcon from '../../icons/CloseIcon.vue';

    export default {
        components: {
            CloseIcon,
        },

        methods: {
            closeModal() {
                this.$emit('close');
            },
        },
    };
</script>
